export class CandidateResumesApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns CandidateResume
     * @throws ApiError
     */
    get() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/candidate-resumes',
        });
    }
    /**
     * @returns CandidateResume
     * @throws ApiError
     */
    create({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/candidate-resumes',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
